import { render, staticRenderFns } from "./DashboardDonationsTable.vue?vue&type=template&id=45a33372"
import script from "./DashboardDonationsTable.vue?vue&type=script&lang=js"
export * from "./DashboardDonationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports